var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import Contentstack from "contentstack";
class ConfigStackController {
  constructor() {
    __publicField(this, "_env", {});
    __publicField(this, "_stack");
    this._stack = null;
  }
  configure(stackConfig, environmentVariables) {
    this._stack = Contentstack.Stack(stackConfig);
    if (environmentVariables) {
      this._env = environmentVariables;
    }
  }
  setCachePolicy(policy) {
    if (this._stack) {
      this._stack.setCachePolicy(policy);
    } else {
      throw new Error(
        "Cannot set cache policy before stack has been configured. Call Contenstack.configure to setup content stack"
      );
    }
  }
  get stack() {
    if (this._stack) {
      return this._stack;
    } else {
      throw new Error(
        "Cannot access stack before it has been configured. Call ConfigStack.configure to setup content stack"
      );
    }
  }
  get env() {
    return this._env;
  }
}
const ConfigStack = new ConfigStackController();
ConfigStack.configure(
  {
    api_key: process.env.CONTENTSTACK_CONFIG_API_KEY,
    branch: process.env.CONTENTSTACK_CONFIG_BRANCH,
    delivery_token: process.env.CONTENTSTACK_CONFIG_DELIVERY_TOKEN,
    environment: process.env.CONTENTSTACK_CONFIG_ENVIRONMENT,
    fetchOptions: {
      retryLimit: 0
    },
    region: process.env.CONTENTSTACK_CONFIG_REGION
  },
  {
    CONTENT_ENTRY_ENVIRONMENT_CLIENT_CONFIGURATION: process.env.CONTENT_ENTRY_ENVIRONMENT_CLIENT_CONFIGURATION,
    CONTENT_ENTRY_ID_CLIENT_CONFIGURATION: process.env.CONTENT_ENTRY_ID_CLIENT_CONFIGURATION
  }
);
export {
  ConfigStack
};
